export const STATUS_LIST = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  PENDING: 'PENDING',
};